<template>
  <div class="container-form">
    <h2>Contractul tau a fost configurat cu succes</h2>
    <p>În câteva secunde, va ajunge pe adresa de email a persoanei de contact.</p>
    <p class="margin-top-30">
      De asemenea, îl poți descărca
      <a
        class="download-link"
        ref="downloadDoc"
        :href="filePath"
        download
      >de aici</a>.
    </p>
    <p class="margin-top-30">
      Tot ce trebuie să mai faci e să trimiți contractul semnat la adresa office@recorder.ro.
    </p>
    <p>
      Dacă dorești să ți-l trimitem înapoi semnat în original, te rugăm să menționezi acest lucru în e-mail.
    </p>
    <p class="margin-top-30">
      Îți mulțumim pentru susținere!
    </p>
    <p class="hide margin-top-30">În continuare</p>
    <ul class="hide margin-top-30">
      <li class="container-flex flex-start">

        <div class="container-col description">
          <div class="vertical-center">Descarcă și semnează contractul.</div>
        </div>
      </li>
      <li class="container-flex flex-start">

        <div class="container-col description">
          <div
            class="vertical-center">Trimite contractul semnat la adresa office@recorder.ro. Dacă dorești să ți-l
            trimitem înapoi semnat în original, te rugăm să menționezi acest lucru în e-mail.
          </div>
        </div>
      </li>
      <li class="container-flex flex-start">

        <div class="container-col description">
          <div
            class="vertical-center"> Îți mulțumim pentru susținere!
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from "vuex";
import axios from "axios";

export default {
  mounted() {
    // this.$refs.downloadDoc.click();

    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      url:
        "/wp-content/themes/recorder/template-parts/formular/deleteGeneratedFile.php",
      data: {
        fileName: this.fileName
      }
    }).then(function (response) {
      console.log("The file could not be deleted");
    });
  },
  computed: {
    ...mapState({
      fileName: state => state.formInputs.fileName,
      filePath: state =>
        "https://recorder.ro/wp-content/temp-documents/" +

        //"https://recorder.ro/wp-content/temp-documents/" +
        state.formInputs.fileName
    })
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-family: realistnarrow, sans-serif;
  font-weight: 900;
}

p {
  margin: 0;
  font-size: 1rem;
}

h5 {
  font-weight: 900;
}

ul {
  margin: 0;
  padding: 0;
}

.container-col {
  height: 70px;
  position: relative;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.container-flex {
  display: flex;
}

.step {
  width: 50px;
  color: gray;
}

.description {
  width: 700px;
}

.step div {
  font-size: 48px;
  font-weight: 900;
}

.description div {
  font-size: 1rem;
  font-weight: 400;
  line-height: 28px;
}

span {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #bd1f23;
}

.app .download-link {
  color: #bd1f23;
  font-weight: 900;
}

@media (max-width: 770px) {
  .container-flex {
    margin-top: 40px;
  }

  .description div {
    font-size: 18px;
    margin-left: 15px;
  }
}

.flex-start {
  justify-content: flex-start;
}
</style>


